/**
 * The JS-side counterpart to the `prefers-reduced-motion` block in
 * `index.css`. A media query cannot reach an element animated through the Web
 * Animations API or revealed by a timer, so anything animated outside CSS has
 * to ask for itself.
 */
export function prefersReducedMotion(): boolean {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
